import React, { useEffect, useState } from "react";

import Quiz from "./components/Quiz";
import Intro from "./components/Intro";

export default function App() {
  // STATES
  // State 1: Questions array
  // this state will be an array of objects in which every object is a question with all the infos (question, category, type, difficulty, correct answer, incorrect answers)
  const [questions, setQuestions] = useState([]);
  console.log(questions);
  // State 2: boolean variable that we will use to render the initial screen or the screen with the questions
  const [gameStart, setGameStart] = useState(false);
  // State 3: This state will hold all form data, that represent all the quiz options chosen by the user
  // We will build conditionally the API URL of the OpenTrivia API (from which we will fetch all the questions) based on the properties of this object
  // Example of the url: https://opentdb.com/api.php?amount=10&category=10&difficulty=hard&type=multiple
  const [quizOptions, setQuizOptions] = useState({
    amount: 5,
    category: "",
    difficulty: "",
    type: "",
  });
  // State 4: boolean variable that we will use to update the Quiz child component UI with correct and wrong answers feedback ONLY AFTER the user check for results
  const [quizComplete, setQuizComplete] = useState(false);

  // EFFECTS
  // Fetching data (questions) from the OpenTrivia API when the form is submitted: we use the gameStart state as target. After the first load gameStart is false and the effect function will do nothing. When the user starts the quiz after filling the quiz options, gameStart (the dependency of useEffect) will become true so the effect function will run again and will fetch data from the OpenTrivia API url using the quizOptions state-object to build the url with parameters chosen by the user.
  useEffect(() => {
    if (gameStart) {
      // Reading the form data inserted by the user (held into the quizOptions state) and build conditionally the API URL
      const amount = `amount=${quizOptions.amount}`;
      const category =
        quizOptions.category && `&category=${quizOptions.category}`;
      const difficulty =
        quizOptions.difficulty && `&difficulty=${quizOptions.difficulty}`;
      const type = quizOptions.type && `&type=${quizOptions.type}`;

      const url = `https://opentdb.com/api.php?${amount}${category}${difficulty}${type}`;
      console.log(url);

      // If the fetch will return 0 results, we will set an array containing a 'warning' string as the value of the questions state
      // The API will return 0 questions when the user requests more questions than those available for some combination (for example in the OpenTrivia API there are only 34 questions for the combo Science + true/False, so if the user requests 50 questions for this combo the API will return 0 results)
      // If instead the fetch will correctly return an array of questions objects, we will loop on this array with the map method to return a similar array as the value of our 'questions' state-array
      // We need to loop on the data.results array fetched from the API because we need to add additional properties ('allAnswers', 'id' and 'userAnswer') in each question object. The property 'allAnswers' will be an array containing all the answers, shuffled. We shuffle the answers because we don't want the correct answer to occupy always the same position for each question. For example if we don't shuffle the allANswers array, the first answer will always be the correct one in the UI (because i build the array in this way, with the correct answwer first : [question.correct_answer, ...question.incorrect_answers])
      // To shuffle the array we use the sort method that will always return a number < 0 or > 0 (randomically) using math.random
      // The Math.random() method returns a random number between 0 to 0.999. When you return Math.random() - 0.5 from the sort() method, it means that the method will return a random number between -0.5 and 0.499 (so a number randomly > 0 OR < 0).
      // This makes the sort() method perform the sort randomly, shuffling the elements in the array without any clear pattern.
      // Other two properties that we need to add to each question object are the id and the 'userAnswer'. The userAnswer property will hold the answer clicked by the user in the UI. The id is needed to identify the question object that will be clicked by the user in the Ui, in order to update his userAnswer property and set it to the answer chose by the user. the userAnswer property is also needed to conditionally add a css class to the answer chosen by the user, in order to visually mark the user's answer to a certain question
      // All the others original properties of each object inside data.result array will simply be spreaded out, but with the addition of these new properties
      fetch(url)
        .then(res => res.json())
        .then(data =>
          setQuestions(() => {
            return data.results.length
              ? data.results.map((question, i) => {
                  return {
                    ...question,
                    id: i + 1,
                    allAnswers: [
                      question.correct_answer,
                      ...question.incorrect_answers,
                    ].sort(() => Math.random() - 0.5),
                    userAnswer: "",
                  };
                })
              : [
                  "There are not enough quizzes in the database for your combination of options. Please try a new combination.",
                ];
          })
        );
    }
  }, [gameStart]);

  // HANDLERS
  // Handler function for Change event on form fields
  function handleChange(e) {
    // Destructuring the event-target object to take out the name and value properties of the form field that triggered the change event
    const { name, value } = e.target;

    // returning a new formData state-object at every change in every form fields
    setQuizOptions(prevState => {
      // Returning a new state-object with the old properties spreaded but with the property with the same name of the input field that fired the change event changed (will override the spreaded property)
      return {
        ...prevState,
        [name]: value,
      };
    });
  }

  // Handler function for Form submit: this action will start the game and reveal the screen with the questions
  function handleSubmit(e) {
    // Checking if the user inserted a number of questions between 5 and 50: if user inserts no number or the number is outside this range, exit the function (the required attribute of the input number field will give feedback to the user in the UI and will prevent the form submit action and the reload of the page)
    if (
      !quizOptions.amount ||
      quizOptions.amount < 5 ||
      quizOptions.amount > 50
    ) {
      return;
    } else {
      // Quando il form non contiene errori, evitiamo il comportamento di default dell'evento submit, ossia evitiamo il reload della pagina
      e.preventDefault();
      console.log(quizOptions);

      // If the user filled the form correctly, the game can start, so we set the gameStart state to true. This will cause a re-render and the UI will now show the <Quiz /> screen
      setGameStart(true);
    }
  }

  // This function will set gameStart to false to show the <Intro /> screen again after the user choose some option combination that produce 0 questions from the fetch. It will also reset the questions state-array to default []
  function rebuildQuiz() {
    setGameStart(false);
    setQuestions([]);
  }

  // Funzione che modifica lo state-array questions andando a restituire un nuovo array quasi del tutto simile al precedente, ma in cui la domanda (question object) a cui l'utente ha dato una risposta avrà la proprietà userAnswer settata proprio sul valore della risposta scelta dell'utente
  // Per identificare l'oggetto da aggiornare nell'array questions, sfruttiamo l'id della domanda che viene passato a questa funzione ad ogni click su una delle risposte
  function addUserAnswer(answer, questionID) {
    // Questa condizione if evita che l'utente possa continuare a rispondere dopo che il quiz è completato
    if (!quizComplete) {
      console.log(answer, questionID);

      setQuestions(prevState => {
        return prevState.map(question => {
          return question.id === questionID
            ? { ...question, userAnswer: answer }
            : question;
        });
      });
    }
  }

  // Funzione innescata quando l'utente clicca sul pulsante .checkAnswers per verificare le sue risposte
  // Nel componente quiz aggiungeremo delle classi condizionali .correct e .wrong solo se quizComplete sarà true, ossia solo DOPO che l'utente cliccherà su .checkAnswers per verificare come sono andate le sue risposte (innescando questa funzione che cambierà lo state quizComplete da false a true, innescando a sua volta un re-render che mostrerà queste classi nella UI per dare un feedback all'utente).
  function checkAnswers() {
    setQuizComplete(true);
  }

  // Funzione che resetta il quiz allo stato iniziale per fare una nuova partita
  function playAgain() {
    setQuestions([]);
    setGameStart(false);
    setQuizOptions({
      amount: 5,
      category: "",
      difficulty: "",
      type: "",
    });
    setQuizComplete(false);
  }

  return (
    <main>
      {gameStart ? (
        // Passing the questions state array to the Quiz child component. This component will render 3 different screens based on what the question state array contains (it will show a 'spinner' screen, a 'no-questions' screen or the screen with the questions)
        // Passing the rebuildQuiz function to allow the user to build again the quiz when his choices of options will not produce any questions fetched from the api
        // passing the handler functions addUserAnswer (triggered when the user select his answer to a quiz) and checkAnswer (triggered when the user check his answers)
        // Passing also the quizComplete state variable (false until the user check his answers). This varible is needed to conditionally add the feedback classes .correct and .wrong ONLY AFTER the user check for answers.
        <Quiz
          questions={questions}
          rebuildQuiz={rebuildQuiz}
          addUserAnswer={addUserAnswer}
          quizComplete={quizComplete}
          checkAnswers={checkAnswers}
          playAgain={playAgain}
        />
      ) : (
        // Passing the state 'quizOptions' to allow the Intro child component to display data in the UI (in the form)
        // Passing also the handlers functions for the change event that occurs on form fields and for the form submit
        <Intro
          quizOptions={quizOptions}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      )}
    </main>
  );
}
